/*
 * @Author: ao-lie lie.ao@firesoon.com
 * @Date: 2023-03-15 17:38:54
 * @LastEditors: ao-lie lie.ao@firesoon.com
 * @LastEditTime: 2023-04-04 11:54:46
 * @FilePath: \ant-ui\src\components\Download\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { Menu, Dropdown } from '@firesoon/antd';
import Button from '../Button';
import { Download, ArrowDown } from '@firesoon/icons-react';
import { IDownload } from './interface';
import './index.less';

const dropdownMenu = (menuLists, handleMenuClick) => {
  return (
    <Menu onClick={handleMenuClick}>
      {menuLists.map((item, index) => {
        return (
          <Menu.Item key={index}>
            <a rel="noopener noreferrer" onClick={(e) => e.preventDefault()}>
              {item.label}
            </a>
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

const Index = ({
  text = '下载',
  type = 'link',
  hideIcon = false,
  loading,
  menuLists = [],
  handleMenuClick,
  disabled,
  ...rest
}: IDownload) => {
  if (menuLists.length > 0) {
    return (
      <Dropdown overlay={() => dropdownMenu(menuLists, handleMenuClick)} className="fs-download" disabled={disabled}>
        <Button type={type} className="fs-download" loading={loading} {...rest}>
          {!hideIcon && !loading && <Download className="fs-download-icon" />}
          {text}
          {loading && '中'}
          {!loading && <ArrowDown />}
        </Button>
      </Dropdown>
    );
  } else {
    return (
      <Button type={type} className="fs-download" loading={loading} disabled={disabled} {...rest}>
        {!hideIcon && !loading && <Download className="fs-download-icon" />}
        {text}
        {loading && '中'}
      </Button>
    );
  }
};

export default Index;
